// src/context/AuthContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { registerUser, loginUser, getCurrentUser, logoutUser } from '../api/auth';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is already logged in when app loads
    const checkLoggedInUser = async () => {
      try {
        const currentUser = await getCurrentUser();
        setUser(currentUser);
      } catch (err) {
        console.error('Failed to get current user', err);
      } finally {
        setLoading(false);
      }
    };

    checkLoggedInUser();
  }, []);

  const register = async (phoneNumber) => {
    setError(null);
    try {
      const result = await registerUser(phoneNumber);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const verifyCode = async (verificationId, code) => {
    setError(null);
    try {
      const userData = await loginUser(verificationId, code);
      setUser(userData);
      return userData;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const logout = async () => {
    setError(null);
    try {
      await logoutUser();
      setUser(null);
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const updateUserProfile = (newUserData) => {
    setUser(prevUser => ({
      ...prevUser,
      ...newUserData
    }));
  };

  const value = {
    user,
    loading,
    error,
    register,
    verifyCode,
    logout,
    updateUserProfile
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
